import { useEffect, useRef } from 'react'

const useHandleClickOutside = (handler) => {
    let domNode = useRef();

    useEffect(() => {
        let maybeHandler = (e) => {
            if (domNode) {

                if (!domNode.current.contains(e.target)) {
                    handler()
                }
            }
        }

        document.addEventListener('mousedown', maybeHandler)

        return () => {
            document.removeEventListener('mousedown', maybeHandler)
        }
    });

    return domNode
}

export default useHandleClickOutside;